import { authAction } from "../actionTypes"

const initialState = {
  user: null,
  checked: false, // true once we know whether a session exists
}

export default function auth(state = initialState, { type, payload }) {
  switch (type) {
    case authAction.AUTH_CHECKED:
    case authAction.AUTH_LOGIN:
      return { ...state, user: payload, checked: true }
    case authAction.AUTH_LOGOUT:
      return { ...state, user: null, checked: true }
    default:
      return state
  }
}
